import { useSearchStore } from '@stores/search.store'
import { useUserStore } from '@stores/user.store'

import { useState } from 'react'

import { Sentiment } from '@types'

import useHttpRequest from '@hooks/useHttpRequest'
import useGetUserID from '@hooks/user/useGetUserId'

import SentimentTrackerButton from './components/sentiment-tracker-button'

import styles from './sentiment-tracker.module.scss'

export default function SentimentTracker(): JSX.Element {
  const { post } = useHttpRequest()
  const search = useSearchStore((st) => st.search)
  const [hasAnswered, setHasAnswered] = useState<Sentiment | null>(null)
  const userId = useGetUserID()
  const profile = useUserStore((state) => state.profile)

  const onClick = (sentiment: Sentiment): void => {
    if (!hasAnswered) {
      post('sentiment', {
        service: 'web',
        body: {
          microRole: search.job.micro,
          location: search.location.name,
          campaign: 'web',
          sentiment,
          userId,
          email: profile?.user?.email ?? null,
        },
      })
      setHasAnswered(sentiment)
    }
  }

  return (
    <div className={styles['sentiment-tracker']}>
      <p className={styles.question}>
        {hasAnswered ? 'Thank you for your feedback!' : 'Are you happy with these job recommendations?'}
      </p>
      <div className={styles.buttons}>
        <SentimentTrackerButton variant="BAD" onClick={(): void => onClick('BAD')} clicked={hasAnswered === 'BAD'} />
        <SentimentTrackerButton variant="GOOD" onClick={(): void => onClick('GOOD')} clicked={hasAnswered === 'GOOD'} />
      </div>
    </div>
  )
}
